import { action, observable, makeObservable } from 'mobx';
import { IFile } from '../../types/IFile';

export interface IProcess extends IFile {
    store?: ProcessStore;
}

export default class ProcessStore {
    process: IProcess = {
        id: '',
        name: '',
        fileRepId: '',
        sha1: '',
        size: 0
    };

    constructor(process: IProcess) {
        makeObservable(this, {
            process: observable,
            update: action
        });

        this.update(process);
    }

    update(process: IProcess): void {
        this.process = {
            ...this.process,
            ...process
        };

        this.process.fileRepId = this.process.fileRepId || this.process.sha1;
    }
}
